// translations
import i18n from '../i18n';
import moment from "moment";

const helper = {
    async changeLanguage(lang) {
        localStorage.language = lang;
        lang === 'en' ? moment.locale('en-gb') : moment.locale(lang);
        await i18n.changeLanguage(lang);
        globalThis.app.forceUpdate();
    }
};

export default helper;
